import UserDetails from "./01UserDetails";
import PartnerDetails from "./02PartnerDetails";
import Relationship from "./03Relationship";
import Children from "./04Children";
import ChildrensLivingsArrangements from "./05ChildrensLivingsArrangements";
import YourIncome from "./06YourIncome";
import YourCurrentPartnerIncome from "./07YouCurrentPartnerIncome";
import FinancialInformation from "./08FinancialInformation";
import FinancialContributions from "./09FinancialContributions";
import ParentingAndHomemakerContributions from "./10ParentingAndHomemakerContributions";
import NonFinancialContributions from "./11NonFinancialContributions";
import SpecialFinancialPayment from "./12SpecialFinancialPayment";
import FutureNeeds from "./13FutureNeeds";
import FinancialResources from "./14FinancialResources";
import Confirmation from "./15Confirmation";

export const formSteps = {
  1: UserDetails,
  2: PartnerDetails,
  3: Relationship,
  4: Children,
  5: ChildrensLivingsArrangements,
  6: YourIncome,
  7: YourCurrentPartnerIncome,
  8: FinancialInformation,
  9: FinancialContributions,
  10: ParentingAndHomemakerContributions,
  11: NonFinancialContributions,
  12: SpecialFinancialPayment,
  13: FutureNeeds,
  14: FinancialResources,
  15: Confirmation,
};
